"use strict";

exports.__esModule = true;
exports.YesNo = YesNo;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Shows a simple i18n friendly Yes / No message based on the
 * whether the `value` prop is truthy.
 */
function YesNo(_ref) {
  var value = _ref.value;
  if (value) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "yes",
      defaultMessage: "Yes"
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "no",
    defaultMessage: "No"
  });
}